(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-b2b"] && !Shopify.designMode) return;
  try {
    
  /**
   * Tracking de la soumission du formulaire B2B Noël.
   *
   * Le formulaire natif Shopify recharge la page après envoi, on ne peut donc pas
   * publier l'événement au submit (la navigation coupe l'envoi au web pixel et le
   * submit ne garantit pas un envoi réussi). On mémorise les champs choisis au
   * submit, puis on publie l'événement custom au rechargement lorsque Shopify
   * confirme la réception (form.posted_successfully?). L'entrée mémorisée est
   * consommée une seule fois : un F5 sur la page de confirmation ne republie rien.
   *
   * Côté web pixel : analytics.subscribe('LeadB2BNoel', ...)
   * Payload : { domaine_interet, boutique_interet }
   */
  (function () {
    const EVENT_NAME = 'LeadB2BNoel';
    const STORAGE_KEY = 'eataly:b2b-noel-lead';

    const form = document.querySelector('form[data-b2b-form="noel"]');
    if (!form) return;

    const publish = (payload) => {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(EVENT_NAME, payload);
      }
    };

    const readPending = () => {
      try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        if (raw === null) return null;
        window.sessionStorage.removeItem(STORAGE_KEY);
        return JSON.parse(raw);
      } catch (error) {
        // sessionStorage indisponible : on publie quand même, sans paramètres.
        return {};
      }
    };

    if (form.querySelector('[data-b2b-form-posted]')) {
      const pending = readPending();
      if (pending !== null) publish(pending);
    }

    form.addEventListener('submit', () => {
      const payload = {};
      const domaine = form.querySelector('#ContactForm-domaine');
      const boutique = form.querySelector('#ContactForm-boutique');
      if (domaine) payload.domaine_interet = domaine.value;
      if (boutique) payload.boutique_interet = boutique.value;
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (error) {
        // ignoré : l'événement sera publié sans paramètres au rechargement
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  var liveUrl = window.location.href;
  var result = liveUrl.includes('form_type=customer');
  var successMessage = document.querySelector('.newsletter-form__message--success.hidden');

  if (result && successMessage) {
    successMessage.classList.remove('hidden');
  }

  } catch(e) { console.error(e); }
})();
})();
